module.exports = __webpack_public_path__ + "img/sec_do_open.b52a3d05.png";